import { Link, useLocation, useRouteError } from "react-router";
import { EmptyState } from "@/components/EmptyState";

export default function NotFoundView() {
  const err = useRouteError() as { status?: number; statusText?: string; message?: string } | undefined;
  const { pathname, search } = useLocation();
  const notFound = err?.status === 404 || !err;
  const where = `${pathname}${search}`;
  return (
    <EmptyState
      title={notFound ? "Not found" : "Something went wrong"}
      hint={
        <>
          {notFound ? "No view is routed at" : "The route that failed was"}{" "}
          <code className="rounded-sm bg-bg px-1 break-all">{where}</code>
          {(err?.message ?? err?.statusText) && <div className="mt-1">{err?.message ?? err?.statusText}</div>}
        </>
      }
      action={
        <Link to="/" className="ctl">
          home
        </Link>
      }
    />
  );
}
